import React from "react";
import { FiRepeat } from "react-icons/fi";
import Tooltip from "components/Tooltip";
import { IconButton, Tooltip as ChakraTooltip } from "@chakra-ui/react";
import {
  CurrentAccountType,
  useProfileContext,
} from "newui/features/Auth/context/ProfileContext";
import { ReactComponent as ActiveProfileCheck } from "icons/proflie-check.svg";
import { ProfileAvatar } from "newui/components/ProfileAvatar/ProfileAvatar";
import { useCurrentCompany } from "hooks/auth";
import { CompanyProfileType } from "newui/features/Auth/types/CompanyProfileType";
import { useHasNotificationsConfiguration } from "hooks/featureFlags";
import { NotificationBell } from "newui/features/Notifications";

interface AppMenuHeaderProps {
  isCollapsed: boolean;
}

export const AppMenuHeader: React.FC<AppMenuHeaderProps> = ({ isCollapsed }) => {
  const { changeProfileType, currentProfile, isAccountSwitchable } =
    useProfileContext();
  const currentCompany = useCurrentCompany();
  const hasNotificationsConfiguration = useHasNotificationsConfiguration();

  const isProcurer = currentProfile === CurrentAccountType.PROCURER;

  const handleSwitchProfile = () => {
    const profileType = isProcurer
      ? CompanyProfileType.SUPPLIER
      : CompanyProfileType.CLIENT;
    changeProfileType(profileType);
  };

  const displayLogo = currentCompany?.logo_path;

  if (isCollapsed) {
    return (
      <div className="flex w-full flex-col items-center gap-2 py-6">
        {displayLogo && (
          <ChakraTooltip label={currentCompany?.name} placement="right" hasArrow>
            <span>
              <ProfileAvatar
                imagePath={displayLogo}
                className="size-10 p-1 shadow-lg"
                isLoading={false}
              />
            </span>
          </ChakraTooltip>
        )}
        {hasNotificationsConfiguration && <NotificationBell />}
      </div>
    );
  }

  return (
    <div
      className="flex items-center gap-4"
      style={{ margin: "32px 12px 20px 16px" }}
    >
      {displayLogo && (
        <div className="shrink-0">
          <ProfileAvatar
            imagePath={displayLogo}
            className="size-12 p-1 shadow-lg"
            isLoading={false}
          />
        </div>
      )}
      <div
        id="profile"
        className="min-w-0 flex-1 overflow-hidden"
      >
        <h2 className="truncate font-roboto text-xl font-bold capitalize text-[#101828]">
          {currentCompany?.name}
        </h2>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1.5">
            <p className="text-sm uppercase text-[#0031DD]">{currentProfile}</p>
            <ActiveProfileCheck />
          </div>
          {isAccountSwitchable && (
            <Tooltip
              label={`Switch Role to ${isProcurer ? "Bidder" : "Procurer"}`}
            >
              <IconButton
                onClick={handleSwitchProfile}
                icon={<FiRepeat />}
                aria-label="Switch Role"
                size="sm"
              />
            </Tooltip>
          )}
        </div>
      </div>
      {hasNotificationsConfiguration && (
        <div className="shrink-0">
          <NotificationBell />
        </div>
      )}
    </div>
  );
};
